var map = {
	"./adult/nn/skrivehastighet-data.json": 796,
	"./adult/no/skrivehastighet-data.json": 797,
	"./child/de/skrivehastighet-data.json": 798,
	"./youth/de/skrivehastighet-data.json": 799,
	"./youth/nn/skrivehastighet-data.json": 800,
	"./youth/no/skrivehastighet-data.json": 801,
	"./youth/se/skrivehastighet-data.json": 802
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;